import { s as staticTextDefault } from "./chunks/config.mjs";
import { b, a, c, e, p } from "./chunks/config.mjs";
const zh_CN = staticTextDefault["zh-CN"];
const en_US = staticTextDefault["en-US"];
export {
  b as allFooter,
  a as allToolbar,
  c as config,
  e as editorExtensionsAttrs,
  en_US,
  p as prefix,
  zh_CN
};
